<template>
  <div class="contact">
    <div class="row" v-if="$event.StartDate||$event.EndDate">
      <el-icon class="calendar"><em-icon-calendar /></el-icon>
      <div class="label-text">
        <div class="label">{{ $t('index.time') }}</div>
        <div class="text">{{ $event.StartDate }} - {{ $event.EndDate }}</div>
      </div>
    </div>
    <div class="row" v-if="$event.Address">
      <el-icon class="location"><em-icon-location /></el-icon>
      <div class="label-text">
        <div class="label">{{ $t('index.address') }}</div>
        <div class="text">
          {{ $event.Address }}
        </div>
      </div>
    </div>
    <div class="row">
      <el-icon class="contact"><em-icon-contact /></el-icon>
      <div class="label-text">
        <el-row style="width: 100%">
          <el-col :span="24" v-if="$event.ContactPerson">
            <div class="label">{{ $t('index.person') }}</div>
            <div class="text">
              {{ $event.ContactPerson }}
            </div>
          </el-col>

          <el-col :span="24" v-if="$event.Telephone">
            <div class="label">{{ $t('index.telephone') }}</div>
            <div class="text">
              {{ $event.Telephone }}
            </div>
          </el-col>

          <el-col :span="24" style="margin-top: 8px" v-if="$event.Email">
            <div class="label">{{ $t('index.email') }}</div>
            <div class="text">
              {{ $event.Email }}
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="row share" v-if="share">
      <el-icon class="share"><em-icon-share /></el-icon>
      <div class="label-text">
        <div class="label">{{ $t('index.share') }}</div>
        <div class="text">
          <v-share />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, defineEmits, inject, onMounted, onUnmounted } from 'vue'
  import VShare from './share.vue'
  const $event = inject('$event')
  const props = defineProps({
    share: {
      type: Boolean,
      default: true,
    },
  })
</script>

<style lang="scss" scoped>
  .row {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    text-align: left;
    flex-wrap: nowrap;
    .el-icon {
      flex: 0 0 36px;
      margin-top: 4px;
      text-align: left;
      justify-content: flex-start;
      svg {
        width: 20px;
        height: 20px;
      }
      &.location,
      &.contact {
        :deep() {
          path {
            stroke: var(--el-color-primary);
          }
        }
      }
      &.share,
      &.calendar {
        :deep() {
          path {
            fill: var(--el-color-primary);
          }
        }
      }
    }
    .label-text {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      .label {
        color: rgba(54, 63, 94, 0.5);
        line-height: 22px;
        text-align: left;
      }
      .text {
        color: #363f5e;
        min-height: 22px;
        line-height: 22px;
        margin: 0;
        margin-block-start: 0;
        margin-block-end: 0;
        text-align: left;
        font-size: 14px;
      }
    }
    &.share {
      .share-container {
        margin-top: 6px;
        display: flex;
        justify-content: center;
        :deep() {
          .share-item {
            margin-right: 18px;
            &:last-child {
              margin-right: 0;
            }
          }
        }
      }
    }
  }
</style>
